export const getElapsedHours = (fecha) => {
  if (!fecha) return null;

  const fechaStatus = new Date(fecha);
  const ahora = new Date();

  if (isNaN(fechaStatus.getTime())) return null;

  const diferencia = ahora - fechaStatus;
  const horas = diferencia / (1000 * 60 * 60);

  return horas;
};